var _ellipse, _path, _path2, _path3, _polygon, _circle, _path4, _path5, _path6, _path7, _path8, _polygon2, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _rect, _path18, _path19, _path20, _rect2, _path21, _rect3, _rect4, _path22, _path23, _path24, _path25, _polygon3, _rect5, _polygon4, _polyline;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgStartup(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 400 300",
    width: 406,
    height: 306,
    className: "illustration styles_illustrationTablet__1DWOa",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 199.76,
    cy: 237.05,
    rx: 15.33,
    ry: 132.65,
    transform: "translate(-38.12 435.81) rotate(-89.76)",
    fill: "#e6e6e6",
    opacity: 0.45
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M200.36,165.15l-8.42,10.56a55.26,55.26,0,0,0-11.78,39.81l1.17,11.89a2.29,2.29,0,0,0,3.81,1.47l21.3-19.34Z",
    fill: "#a8a8a8"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M259.49,165.15l8.42,10.56a55.21,55.21,0,0,1,11.78,39.81l-1.16,11.89a2.29,2.29,0,0,1-3.81,1.47l-21.3-19.34Z",
    fill: "#a8a8a8"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M230,71.43s-62.23,34.15-23.52,138.11h47.05C292.19,105.58,230,71.43,230,71.43Z",
    fill: "#e6e6e6"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "253.49 209.54 251.4 217.51 208.71 217.51 206.44 208.59 253.49 209.54",
    fill: "#a8a8a8"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 230.41,
    cy: 132.42,
    r: 15.98,
    fill: "#fff",
    stroke: "#878787",
    strokeMiterlimit: 10,
    strokeWidth: 4
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M174.52,178.36l-13.88,14.49c.71-4.12,1.41-9.62,2.43-16.93,3.88-28-17.24-31.44-17.24-31.44s-9.93,58.45,2,59.7c.85.08,1.63.16,2.36.21l-.68,4.81c19,3.72,30.29-28.68,30.29-28.68Z",
    fill: "#68e1fd"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M174.52,178.36l-13.88,14.49c.71-4.12,1.41-9.62,2.43-16.93,3.88-28-17.24-31.44-17.24-31.44s-9.93,58.45,2,59.7c.85.08,1.63.16,2.36.21l-.68,4.81c19,3.72,30.29-28.68,30.29-28.68Z",
    fill: "#fff",
    opacity: 0.46
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M145.83,144.48a18.07,18.07,0,0,0-4.88-1,83.11,83.11,0,0,0-36.17,6.32c-21,8.62,7.13,67.38,7.13,67.38l35.54-2.51S172.59,154.12,145.83,144.48Z",
    fill: "#68e1fd"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M110.8,154.12s13.52.68,12.82,21.63,8.81,15.52,8.81,15.52L148,166.68a5,5,0,0,1,5.59,4.64c.43,3.36-5.52,17.64-9.8,27.35a13.8,13.8,0,0,0,3.64,16h0l-35.54,2.51-1.23-2.66Z",
    opacity: 0.08
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M119.41,124.81a31.1,31.1,0,0,1,3.91,7.41,2.53,2.53,0,0,1-1.73,3.15,5.58,5.58,0,0,1-5.91-1.39l-3.55-3a4.53,4.53,0,0,1-.75-5.18C112.79,122.56,117.74,122.22,119.41,124.81Z",
    fill: "#f4a28c"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    points: "114.23 130.76 112.36 147.2 121.49 147.59 119.19 135.47 114.23 130.76",
    fill: "#f4a28c"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M118.44,125.63a21,21,0,0,1-4.19,2.06,4.21,4.21,0,0,1,2.36,4,3.44,3.44,0,0,1-2.87,3.29l-3.23-5.62a5.14,5.14,0,0,1-.1-5.27,19.4,19.4,0,0,1,1.32-2c1.23-1.59,4.22-1.92,5-3.85a1.22,1.22,0,0,1,2.07-.3c1.26,1.55,2.54,4.4.79,6.69A5.06,5.06,0,0,1,118.44,125.63Z",
    fill: "#24285b"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M117,131.26s-1-1.65-2.2-.78.28,3.27,2.13,2.48Z",
    fill: "#f4a28c"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M121.13,127.49l2.2,1a.81.81,0,0,1,.21,1.35l-1.48,1.3Z",
    fill: "#f4a28c"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M119.06,135.87a6,6,0,0,1-3.29-1s.13,3.05,4.08,5.13Z",
    fill: "#ce8172",
    opacity: 0.31
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M111.91,217.21s-18.45,6.77-14,17.06c3.31,7.72,20.27,1.21,31.38-2a33.23,33.23,0,0,1,12.23-1.18c7.62.68,17.29,3.06,20.57-1.35,4.82-6.48-1.3-12.21-14.6-15Z",
    fill: "#24285b"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M115.32,161a11.24,11.24,0,0,0-21.38-1.85,36.35,36.35,0,0,0-2.46,15.65c.93,23,5.38,42.5,22.65,39.49S148,175,148,175l-7.85-4.48L115.75,194S118.52,175.22,115.32,161Z",
    fill: "#68e1fd"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M115.32,161a11.24,11.24,0,0,0-21.38-1.85,36.35,36.35,0,0,0-2.46,15.65c.93,23,5.38,42.5,22.65,39.49S148,175,148,175l-7.85-4.48L115.75,194S118.52,175.22,115.32,161Z",
    fill: "#fff",
    opacity: 0.46
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M141.11,171.06s4.16-7.43,8.52-5.86-1.67,3.58-1.67,3.58,3.06,2.7-1,5.61Z",
    fill: "#f4a28c"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M134,225.79l1.13,5.32s5.45,4,8.89,1.53S142.19,227.23,134,225.79Z",
    fill: "#68e1fd"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 203.26,
    y: 158.46,
    width: 13.48,
    height: 13.48,
    rx: 2.17,
    fill: "#878787",
    opacity: 0.55
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M110.22,147.8s-.07-3.89,2.72-5.7c2.1-1.37,7,1,9.23,2.21a2.73,2.73,0,0,1,1.4,3.06,2.43,2.43,0,0,1-2.08,1.73C118.2,149.77,110.22,147.8,110.22,147.8Z",
    fill: "#68e1fd"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M110.22,147.8s-.07-3.89,2.72-5.7c2.1-1.37,7,1,9.23,2.21a2.73,2.73,0,0,1,1.4,3.06,2.43,2.43,0,0,1-2.08,1.73C118.2,149.77,110.22,147.8,110.22,147.8Z",
    fill: "#fff",
    opacity: 0.46
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M174,162.86s-3-18.92,5.88-21.05-.31,17.07,11,14.44,8.33-17.47,17.84-14.92c7.6,2,1.33,23.87,1.33,23.87",
    fill: "none",
    stroke: "#24285b",
    strokeMiterlimit: 10
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 168.48,
    y: 158.67,
    width: 10.96,
    height: 19.5,
    transform: "translate(25.56 -22.9) rotate(8.13)",
    fill: "#ffd200"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M179.83,180.52s2.44-9.08-3.39-9.1S172.81,181,179.83,180.52Z",
    fill: "#f4a28c"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 210.37,
    y: 48.83,
    width: 40.08,
    height: 6.9,
    fill: "#24285b"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 210.37,
    y: 48.83,
    width: 30.31,
    height: 6.9,
    fill: "#68e1fd"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M202.24,104.58h55.45a152.29,152.29,0,0,0-24.53-36,4.36,4.36,0,0,0-6.39,0C220.82,75,208.1,89.81,202.24,104.58Z",
    fill: "#a8a8a8"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M304.45,224.19s6.23-1.68,7.61-7.46c0,0-9.63-2-9.95,8Z",
    fill: "#68e1fd",
    opacity: 0.58
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M303.69,223.57s4.38-6.86.58-13.29a11.06,11.06,0,0,0-4.13,13.29Z",
    fill: "#68e1fd",
    opacity: 0.73
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M302.58,223.57s-2.27-7.27-9.2-8.67c0,0-1.33,4.7,4.45,8.67Z",
    fill: "#68e1fd"
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    points: "307.09 223.42 305.79 232.04 297.85 232.04 296.71 223.42 307.09 223.42",
    fill: "#24285b"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 97.72,
    y: 73.49,
    width: 36.13,
    height: 25.34,
    fill: "#ffd200"
  })), _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    points: "120.39 95.09 115.94 107.55 111.96 95.09 120.39 95.09",
    fill: "#ffd200"
  })), _polyline || (_polyline = /*#__PURE__*/React.createElement("polyline", {
    points: "109.74 86.94 114.08 91.99 121.61 81.27",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStartup);
export default __webpack_public_path__ + "static/media/startup.6d323afd811510489c4dd03058f5c57d.svg";
export { ForwardRef as ReactComponent };